/* tslint:disable */

declare var Object: any;
export interface CrmCaseStageInterface {
  "id"?: number;
  "name"?: string;
  "key_name"?: string;
}

export class CrmCaseStage implements CrmCaseStageInterface {
  "id": number;
  "name": string;
  "key_name": string;
  constructor(data?: CrmCaseStageInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `CrmCaseStage`.
   */
  public static getModelName() {
    return "CrmCaseStage";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of CrmCaseStage for dynamic purposes.
  **/
  public static factory(data: CrmCaseStageInterface): CrmCaseStage{
    return new CrmCaseStage(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'CrmCaseStage',
      plural: 'CrmCaseStages',
      path: 'CrmCaseStages',
      idName: 'id',
      properties: {
        "id": {
          name: 'id',
          type: 'number'
        },
        "name": {
          name: 'name',
          type: 'string'
        },
        "key_name": {
          name: 'key_name',
          type: 'string'
        },
      },
      relations: {
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/sdk/models/CrmCaseStage.ts